import React, { Component } from "react";

import { Icon } from "@mui/material";

import Text from "../../components/Text";

import "./Contractor.styl";
import env from "../../../env";

class Contractor extends Component {
    render() {
        return (
            <div tabIndex={0} aria-label="Conteúdo da Página Empreiteiras" className="Contractor">
                <section id="presentation" className="frame padded flex ai-c" aria-label="Apresentação do produto para empreiteiras" style={{ backgroundImage: `url(${env.images.contractor})`}}>
                    <div className="darken">
                        <Text className="header align-center flex ai-c jc-c" as="h1"><Icon className="icon">lightbulb</Icon>Empreiteiras</Text>
                        <Text className="align-center">Conheça as vantagens de utilizar o Geolux como sua ferramenta de gestão.</Text>
                    </div>
                </section>
                <section id="in-field-operations" className="dark image frame padded equally">
                    <div className="flex row reverse">
                        <div className="flex ai-c jc-c flex-3">
                            <div>
                                <Text className="header mobile" as="h2"><Icon className="header-icon">location_on</Icon>Operações em Campo</Text>
                                <div className="flex jc-c">
                                    <img className="image" src={env.images.cityHall.inFieldOperations} title="Atualize e acompanhe as execuções de OSs em tempo real" alt="Imagem ilustrativa de uma pessoa mexendo em um tablet" />
                                </div>
                                <Text tabIndex={-1} className="image-subtitle">Atualize e acompanhe as execuções de OSs em tempo real.</Text>
                            </div>
                        </div>
                        <div className="flex ai-c flex-2">
                            <div>
                                <Text className="header desktop" as="h2"><Icon className="header-icon">location_on</Icon>Operações em Campo</Text>
                                <Text className="text">O Geolux conta com um aplicativo que permite suas equipes de manutenção atualizar e abrir novas ordens de serviço em tempo real.</Text>
                                <Text className="text">Se o local não possuir conexão, não tem problema! O sistema irá sincronizar os dados assim que a equipe conseguir se conectar.</Text>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="ilumination-park" className="dark image frame padded equally">
                    <div className="flex row">
                        <div className="flex ai-c jc-c flex-3">
                            <div>
                                <Text className="header mobile" as="h2"><Icon className="header-icon">lightbulb_outline</Icon>Parque de Iluminação</Text>
                                <div className="flex jc-c">
                                    <img className="image" src={env.images.cityHall.iluminationPark} title="Visualize seu parque de iluminação com o mapa de pontos luminosos" alt="Exemplo do mapa de pontos luminosos do Geolux" />
                                </div>
                                <Text tabIndex={-1} className="image-subtitle">Visualize seu parque de iluminação com o mapa de pontos luminosos.</Text>
                            </div>
                        </div>
                        <div className="flex ai-c flex-2">
                            <div>
                                <Text className="header desktop" as="h2"><Icon className="header-icon">lightbulb_outline</Icon>Parque de Iluminação</Text>
                                <Text className="text">Visualize como o parque de iluminação da cidade é composto com o uso de diversos tipos de mapas.</Text>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="team-management" className="dark image frame padded equally">
                    <div className="flex row reverse">
                        <div className="flex ai-c jc-c flex-3">
                            <div>
                                <Text className="header mobile" as="h2"><Icon className="header-icon">people</Icon>Gestão de Equipes</Text>
                                <div className="flex jc-c">
                                    <img className="image" src={env.images.cityHall.teamManagement} title="Acompanhe a produtividade das suas equipes" alt="Imagem ilustrativa de uma equipe em uma reunião" />
                                </div>
                                <Text tabIndex={-1} className="image-subtitle">Acompanhe a produtividade das suas equipes.</Text>
                            </div>
                        </div>
                        <div className="flex ai-c flex-2">
                            <div>
                                <Text className="header desktop" as="h2"><Icon className="header-icon">people</Icon>Gestão de Equipes</Text>
                                <Text className="text">O sistema permite que equipes e gerência visualizem todos os dados das equipes, desde rondas executadas até detalhes de cada OS.</Text>
                                <Text className="text">Com esses dados você pode identificar problemas que estão impactando na eficiência dos serviços de manutenção.</Text>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="material-management" className="dark image frame padded equally">
                    <div className="flex row">
                        <div className="flex ai-c jc-c flex-3">
                            <div>
                            <Text className="header mobile" as="h2"><Icon className="header-icon">business</Icon>Gestão de Materiais</Text>
                                <div className="flex jc-c">
                                    <img className="image" src={env.images.cityHall.stockManagement} title="Entrada e saída automatizada" alt="Várias e várias lâmpadas, umas em cima das outras" />
                                </div>
                                <Text tabIndex={-1} className="image-subtitle">Entrada e saída automatizada.</Text>
                            </div>
                        </div>
                        <div className="flex ai-c flex-2">
                            <div>
                                <Text className="flex ai-c header desktop" as="h2"><Icon className="header-icon">business</Icon>Gestão de Materiais</Text>
                                <Text className="text">Quando um serviço é executado, o sistema dá baixa em todos os materiais utilizados.</Text>
                                <Text className="text">Materiais com defeito dentro da garantia são automaticamente marcados para você poder visualizar os dados depois.</Text>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="demand-management" className="dark image frame padded equally">
                    <div className="flex row reverse">
                        <div className="flex ai-c jc-c flex-3">
                            <div>
                                <Text className="header mobile" as="h2"><Icon className="header-icon">sentiment_very_satisfied</Icon>Gestão de Demandas</Text>
                                <div className="flex jc-c">
                                    <img className="image" src={env.images.cityHall.demandManagement} title="Encontre gargalos e melhore a eficiência de atendimento" alt="Imagem ilustrativa de pessoas analisando dados e planejando alguma coisa" />
                                </div>
                                <Text tabIndex={-1} className="image-subtitle">Encontre gargalos e melhore a eficiência de atendimento.</Text>
                            </div>
                        </div>
                        <div className="flex ai-c flex-2">
                            <div>
                                <Text className="header desktop" as="h2"><Icon className="header-icon">sentiment_very_satisfied</Icon>Gestão de Demandas</Text>
                                <Text className="text">Saiba quais são os locais onde mais ordens de serviço são abertas e acompanhe o andamento das execuções.</Text>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Contractor;
